export const GET_ADMIN_INFOS_DISPONIBILITY_PRODUCTS =
  '/admin/infos-disponibility-products'
